import { isPlatformBrowser } from '@angular/common'
import type { AfterViewInit, ElementRef } from '@angular/core'
import { Component, PLATFORM_ID, inject, viewChild } from '@angular/core'
import { Router } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-welcome-dialog',
  templateUrl: './welcome-dialog.component.html',
  styleUrl: './welcome-dialog.component.scss',
  imports: [TranslatePipe],
})
export class WelcomeDialogComponent implements AfterViewInit {
  private readonly router = inject(Router)
  private readonly platformId = inject(PLATFORM_ID)

  private readonly dialog = viewChild<ElementRef<HTMLDialogElement>>('dialog')

  ngAfterViewInit(): void {
    const dialog = this.dialog()
    if (isPlatformBrowser(this.platformId) && dialog && !this.isRead()) {
      dialog.nativeElement.show()
    }
  }

  close(): void {
    const dialog = this.dialog()
    if (dialog) {
      dialog.nativeElement.close()
      this.markAsRead()
    }
  }

  isRead(): boolean {
    try {
      if (window.localStorage) {
        return localStorage.getItem('welcomeDialogRead') === 'true'
      }
    } catch (error) {
      console.warn('Local storage is not available:', error)
    }
    return false
  }

  async goToAccountCreation(): Promise<void> {
    this.close()
    await this.router.navigate(['auth', 'register'])
  }

  private markAsRead(): void {
    try {
      if (window.localStorage) {
        localStorage.setItem('welcomeDialogRead', 'true')
      }
    } catch (error) {
      console.warn('Local storage is not available:', error)
    }
  }
}
